import { createIsomorphicFn } from '@tanstack/react-start'
import { getRequest } from '@tanstack/react-start/server'
import { setCookie } from '@/lib/cookies'

/** Which drawing the report's radar uses: the classic lines, or the ring-per-indicator design the landing's hero shows. */
export type RadarStyle = 'classic' | 'rings'

// A COOKIE, not localStorage: the report's radar is server-rendered, so the preference has to travel with the request
// or SSR paints the classic drawing and the rings only appear after hydration. Same shape as server-theme.
const RADAR_STYLE_COOKIE = 'radar-style'
const MAX_AGE_SECONDS = 60 * 60 * 24 * 365

const cookieRadarStyle = (cookie: string): RadarStyle =>
  /(?:^|;\s*)radar-style=rings(?:;|$)/.test(cookie) ? 'rings' : 'classic'

// The CLIENT variant is not a no-op: the root loader re-runs on the client, and it must return the same value the
// server read off the request, or the radar would redraw on the first navigation.
export const resolveRadarStyle = createIsomorphicFn()
  .server((): RadarStyle => cookieRadarStyle(getRequest().headers.get('cookie') ?? ''))
  .client((): RadarStyle => cookieRadarStyle(typeof document === 'undefined' ? '' : document.cookie))

/** Client-only (setCookie no-ops during SSR); a year, so the choice survives the session it was made in. */
export function persistRadarStyle(style: RadarStyle): void {
  setCookie(RADAR_STYLE_COOKIE, style, { maxAge: MAX_AGE_SECONDS })
}

/** Reads the cookie the client already has; undefined during SSR, where the root loader supplies the value instead. */
export function clientRadarStyle(): RadarStyle {
  return cookieRadarStyle(typeof document === 'undefined' ? '' : document.cookie)
}
